import { SVGProps } from 'react';
export const EyeCircleIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg data-icon viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="12" cy="12" r="12" fill="#fff" />
      <path
        fill="#000"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0005 7.5C9.1289 7.5 6.69099 9.36249 5.83134 11.9468C5.81948 11.9824 5.81949 12.0212 5.83137 12.0568C6.69209 14.6392 9.12907 16.5 11.9994 16.5C14.871 16.5 17.3089 14.6375 18.1686 12.0532C18.1804 12.0176 18.1804 11.9788 18.1685 11.9432C17.3078 9.36076 14.8708 7.5 12.0005 7.5ZM4.88246 11.6311C5.87396 8.65047 8.68546 6.5 12.0005 6.5C15.3141 6.5 18.1245 8.64848 19.1172 11.627C19.1974 11.8677 19.1975 12.1281 19.1174 12.3689C18.1259 15.3495 15.3144 17.5 11.9994 17.5C8.68583 17.5 5.87541 15.3515 4.88268 12.373C4.80245 12.1323 4.80237 11.8719 4.88246 11.6311ZM9.49999 12C9.49999 10.6193 10.6193 9.5 12 9.5C13.3807 9.5 14.5 10.6193 14.5 12C14.5 13.3807 13.3807 14.5 12 14.5C10.6193 14.5 9.49999 13.3807 9.49999 12Z"
      />
    </svg>
  );
};
